module.exports = __webpack_public_path__ + "img/logo-cashforce.0f6d491a.svg";